import get from 'lodash-es/get';
import { createSelector } from 'reselect';

//pendingWrites for all databases
export const pendingWrites = (state, couchdbName) => get(state, `dreamdb.couchdb-${couchdbName}.pendingWrites`);

//failedWrites for all databases
export const failedWrites = (state, couchdbName) => get(state, `dreamdb.couchdb-${couchdbName}.failedWrites`);

//pendingWrites for given dbName
export const pendingWritesByDbName = (state, couchdbName, dbName) => get(state, `dreamdb.couchdb-${couchdbName}.pendingWrites.${dbName}`);
//failedWrites for given dbName
export const failedWritesByDbName = (state, couchdbName, dbName) => get(state, `dreamdb.couchdb-${couchdbName}.failedWrites.${dbName}`);

//pendingWrites for given dbName and docId
export const pendingWritesByDocId = (state, couchdbName, dbName, docId) => get(state, `dreamdb.couchdb-${couchdbName}.pendingWrites.${dbName}.${docId}`);
//failedWrites for given dbName and docId
export const failedWritesByDocId = (state, couchdbName, dbName, docId) => get(state, `dreamdb.couchdb-${couchdbName}.failedWrites.${dbName}.${docId}`);

/**
 * It returns true if connected with the server. Otherwise, false.
 * @param {Object} state 
 * @param {String} couchdbName 
 */
export const connected = (state, couchdbName) => get(state, `dreamdb.couchdb-${couchdbName}.connected`);

/**
 * It returns true if client is disconnected due to connection lost.
 * @param {Object} state 
 * @param {String} couchdbName 
 */
export const connectionLost = (state, couchdbName) => get(state, `dreamdb.couchdb-${couchdbName}.connectionLost`);

/**
 * It returns count of total pending docs
 */
export const syncPendingDocsCount = createSelector(
  pendingWrites,
  pendingWrites => {
    if(!pendingWrites) {
      return 0;
    }

    return Object.values(pendingWrites).reduce((totalCount, item) => {
      let values = Object.values(item);
      if(values && values.length) {
        totalCount += values.length;
      }
      return totalCount;
    }, 0);
  }
);

/**
 * It returns count of total failed docs
 */
export const failedDocsCount = createSelector(
  failedWrites,
  failedWrites => {
    if(!failedWrites) {
      return 0;
    }

    return Object.values(failedWrites).reduce((totalCount, item) => {
      let values = Object.values(item);
      if(values && values.length) {
        totalCount += values.length;
      }
      return totalCount;
    }, 0);
  }
);

/**
 * It returns time from that sync is pending.
 */
export const syncPendingSince = createSelector(
  pendingWrites,
  pendingWrites => {

    if(!pendingWrites) {
      return null;
    }

    return Object.values(pendingWrites).reduce((pendingSince, item) => {
      let values = Object.values(item);
      if(values && values.length) {
        
        if(!pendingSince) {
          pendingSince = Math.min(...values);
          return pendingSince;
        }
        
        pendingSince = Math.min(pendingSince, ...values);
      }

      return pendingSince;
    }, null);
  }
);